import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
  Button, // Import FormFeedback for error messages
} from "reactstrap";
import { useFormik } from "formik";

import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MediaModal from "../../../Kangaroo/PagesSection/Component/MediaModal";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DashboardMenuService from "../../../services/KangarooServices/Intelligence/DashboardMenuService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const ProductServiceForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const authUser = getLoggedInUser();
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");

  const [detailData, setDetailData] = useState({});
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const toggleMedia = () => setIsMediaOpen(!isMediaOpen);
  const fetchPageDetail = async () => {
    try {
      const response = await DashboardMenuService.getdetail(id);
      setDetailData(response);

      setSelectedMedia(response.logoImage);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) fetchPageDetail();
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: detailData?.id || "",

      name: detailData?.name || "",
      logoImageId: detailData?.logoImageId || "",
      logoImage: detailData?.logoImage?.url,
      orderIndex: detailData.orderIndex,
      url: detailData?.url,
      isDestination: detailData?.isDestination,
      isOnshoreIntelMenu:
        detailData?.isOnshoreIntelMenu !== undefined
          ? detailData.isOnshoreIntelMenu
          : isOnshoreAdmin,
    },
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        // Build payload
        const payload = {
          name: values.name,
          logoImageId: selectedMedia?.id || null,
          orderIndex: Number(values.orderIndex),
          url: values?.url,
          isOnshoreIntelMenu: Boolean(values.isOnshoreIntelMenu),
          isDestination: Boolean(values?.isDestination),
        };

        if (values?.id) {
          await DashboardMenuService.update(values?.id, payload);
          toast.success("Widget updated successfully");
        } else {
          await DashboardMenuService.create(payload);
          toast.success("Widget created successfully");
        }

        navigate(`/product-services`);
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const breadcrumbItems = [
    { title: "Back to List", link: "/product-services" },
  ];
  const PageTypeEnum = {
    SingleText: 1,
    ParagraphText: 2,
    List: 3,
    Image: 4,
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Product & Services Form"
          pageTitle="Product & Services"
          breadcrumbItems={breadcrumbItems}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {id ? "Update" : "Create"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => navigate("/product-services")}
            >
              Cancel
            </button>
          </div>

          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  {/* Title Field */}

                  {/* Subtitle Field */}
                  <FormGroup className="mb-3">
                    <Label htmlFor="name">Name</Label>
                    <Input
                      id="name"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.name && !!formik.errors.name}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <FormFeedback>{formik.errors.name}</FormFeedback>
                    )}
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="name">Order index</Label>
                    <Input
                      id="orderIndex"
                      name="orderIndex"
                      type="number"
                      value={formik.values.orderIndex}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.orderIndex && !!formik.errors.orderIndex
                      }
                    />
                    {formik.touched.orderIndex && formik.errors.orderIndex && (
                      <FormFeedback>{formik.errors.orderIndex}</FormFeedback>
                    )}
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="name">Url</Label>
                    <Input
                      id="url"
                      name="url"
                      value={formik.values.url}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.url && !!formik.errors.url}
                    />
                    {formik.touched.url && formik.errors.url && (
                      <FormFeedback>{formik.errors.url}</FormFeedback>
                    )}
                  </FormGroup>
                  {isSuperAdmin && (
                    <div className="mb-3">
                      <Label>Intelligence Display</Label>
                      <select
                        name="isOnshoreIntelMenu"
                        className="form-select"
                        value={String(formik.values.isOnshoreIntelMenu)}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "isOnshoreIntelMenu",
                            e.target.value === "true",
                          )
                        }
                      >
                        <option value="true">Onshore Intel Menu</option>
                        <option value="false">Offshore Intel Menu</option>
                      </select>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>

            <Col lg={4}>
              <FormGroup className="d-flex justify-content-between">
                <Label>Is Destination?</Label>
                <Input
                  type="checkbox"
                  checked={formik.values.isDestination}
                  onChange={(e) =>
                    formik.setFieldValue("isDestination", e.target.checked)
                  }
                />
              </FormGroup>
              <Card>
                <CardBody>
                  <Label style={{ cursor: "pointer" }}>Featured Media</Label>
                  {selectedMedia ? (
                    <div className="text-center p-3 border rounded shadow-sm bg-light">
                      {/* Image Preview */}
                      <div
                        style={{
                          maxHeight: "220px",
                          overflow: "hidden",
                          borderRadius: "10px",
                          border: "1px solid #ddd",
                        }}
                        className="mb-3"
                      >
                        <img
                          src={`${imageBaseApi}${selectedMedia?.url}`}
                          alt="Featured"
                          style={{ width: "100%", objectFit: "contain" }}
                          className="img-fluid hover-zoom"
                        />
                      </div>

                      {/* Image Info */}
                      <div className="mb-2">
                        <div className="fw-semibold">
                          {selectedMedia.name || "Featured Image"}
                        </div>

                        {selectedMedia.size && (
                          <small className="text-muted">
                            Size: {(selectedMedia.size / 1024).toFixed(1)} KB
                          </small>
                        )}
                      </div>

                      {/* Buttons */}
                      <div className="d-flex gap-2 justify-content-center">
                        <Button
                          size="sm"
                          outline
                          color="primary"
                          className="rounded-pill px-3"
                          onClick={toggleMedia}
                        >
                          Change
                        </Button>

                        <Button
                          size="sm"
                          outline
                          color="danger"
                          className="rounded-pill px-3"
                          onClick={() => {
                            // formik.setFieldValue("logoImageId", "");
                            setSelectedMedia(null);
                            formik.setFieldValue("logoImage", null);
                          }}
                        >
                          <i className="ri-delete-bin-5-line me-1"></i>
                          Remove
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="p-4 border rounded text-center bg-light">
                      <i className="ri-image-add-line fs-1 text-secondary"></i>
                      <h6 className="mt-2 mb-2 text-muted">
                        No logoImage selected
                      </h6>
                      <h6 className="mb-3 text-muted">1200 x 630</h6>
                      <Button
                        outline
                        color="secondary"
                        className="rounded-pill px-4"
                        onClick={toggleMedia}
                      >
                        <i className="ri-image-add-line me-1"></i> Choose
                        Featured Image
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </form>
      </div>

      <MediaModal
        isOpen={isMediaOpen}
        toggle={toggleMedia}
        selectedMedia={selectedMedia}
        setSelectedMedia={setSelectedMedia}
      />
    </Container>
  );
};

export default ProductServiceForm;
